import React, { useEffect, useState } from "react";
import { Modal, Form, message } from "antd";
import { AddUserModalProps } from "./AddUserModalInterface";
import StyledDropdown from "src/components/reusable/StyledDropdown";
import StyledTextInput from "src/components/reusable/StyledTextInput";

const AddUserModal: React.FC<AddUserModalProps> = ({
  open,
  onClose,
  onSubmit,
  tenantOptions, // ✅ use this
}) => {
  const [form] = Form.useForm();
  const selectedTenant = Form.useWatch("tenant_email", form);
  const selectedStatus = Form.useWatch("status", form);
const [, setLoading] = useState(false);
  useEffect(() => {
    if (open) {
      form.resetFields();
      form.setFieldsValue({ status: "active" });
    }
  }, [open, form]);

const handleOk = async () => {
  setLoading(true);
  try {
    const values = await form.validateFields();
    await onSubmit(values); // if onSubmit returns a promise
    onClose();
  } catch {
    message.error("Please fix validation errors.");
  } finally {
    setLoading(false);
  }
};

const handleTenantChange = (value: string) => {
  form.setFieldsValue({ tenant_email: value });
};

  return (
    <Modal
      title="Add New User"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      okText="Add User"
      cancelText="Cancel"
      destroyOnClose
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          user_name: "",
          user_email: "",
          tenant_email: undefined, // ✅ updated
          status: "active",
        }}
      >
        <Form.Item
          name="user_name"
          label="User Name"
          rules={[{ required: true, message: "Please enter a name" }]}
        >
          <StyledTextInput placeholder="Enter user name"  aria-label="User Name"/>
        </Form.Item>

        <Form.Item
          name="user_email"
          label="User Email"
          rules={[
            { required: true, message: "Please enter a user email" },
            {
              type: "email",
              message: "Please enter a valid email address",
            },
          ]}
        >
          <StyledTextInput placeholder="Enter user email"  aria-label="User Email"/>
        </Form.Item>

        <Form.Item
          name="tenant_email" // ✅ match API
          label="Tenant"
          rules={[{ required: true, message: "Please select a tenant" }]}
        >
         <StyledDropdown
  placeholder="Select tenant"
  aria-label="Tenant"
  value={selectedTenant}
  onChange={value => handleTenantChange(value as string)}
  options={tenantOptions.map(tenant => ({
    value: tenant.tenant_email,
    label: `${tenant.tenant_name} (${tenant.tenant_email})`
  }))}
  popupClassName="custom-dropdown-menu"
/>
        </Form.Item>

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select a status" }]}
        >
          <StyledDropdown
            placeholder="Select status"
            disabled
            aria-label="Status"
            value={selectedStatus}
            options={[{ label: "Active", value: "active" }]}
            popupClassName="custom-dropdown-menu"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddUserModal;
